/**
 * Valorile de politică, citite de la server o singură dată.
 *
 * Regula pe care o servește: orice valoare care s-ar putea schimba fără ca
 * logica să se schimbe trăiește într-un singur loc numit — și locul ăla e
 * backend/policy.py, nu o constantă scrisă a doua oară aici. Eticheta se
 * derivă din valoare; „maximum 2MB" scris de mână rămâne în urmă fără ca ceva
 * să pice, exact ce s-a întâmplat cu „Maxim 15 MB" după ce limita a urcat.
 */
import { api } from "@/lib/api";

const GB = 1024 * 1024 * 1024;
const MB = 1024 * 1024;
const KB = 1024;

/** Cifra pe care o citește un om. Aceeași regulă ca policy.human_bytes. */
export function humanBytes(n) {
  const value = Number(n) || 0;
  if (value >= GB) return `${(value / GB).toFixed(1).replace(/\.0$/, "")} GB`;
  if (value >= 100 * MB) return `${Math.round(value / MB)} MB`;
  if (value >= MB) return `${(value / MB).toFixed(1).replace(/\.0$/, "")} MB`;
  if (value >= KB) return `${Math.round(value / KB)} KB`;
  return `${value} B`;
}

let cached = null;
let inflight = null;

/** Valorile, cerute o dată și ținute. Un eșec nu se memorează: se reîncearcă. */
export async function policy() {
  if (cached) return cached;
  if (!inflight) {
    inflight = api.get("/policy")
      .then((r) => { cached = r.data?.values || {}; return cached; })
      .finally(() => { inflight = null; });
  }
  return inflight;
}

/** Doar pentru teste: uită ce s-a citit. */
export function forgetPolicy() {
  cached = null;
  inflight = null;
}
